export const CartItem = ({ 
  item, 
  cartItemKey,
  onQuantityChange, 
  onRemove, 
  onMoveToWishlist, 
  onProductClick,
  onSizeChange,
  selectedSize 
}) => {
  const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
    ? item.variantPrices[selectedSize] 
    : item.sellingPrice;
    
  const savings = item.originalPrice ? (item.originalPrice - itemPrice) * item.quantity : 0;

  return (
    <div className="premium-cart-item">
      <div className="premium-cart-item-image" onClick={() => onProductClick(item)}>
        <img
          src={
            item.productImage
              ? `https://api.dremerz.net/uploads/${item.productImage}`
              : "default-image.jpg"
          }
          loading="lazy"
          alt={item.productName || "Product"}
        />
        {/* <div className="premium-cart-item-badge">{item.brandName}</div> */}
      </div>
      
      <div className="premium-cart-item-details">
        <h3 onClick={() => onProductClick(item)}>{item.productName}</h3>
        
        {/* Size Selector */}
        <div className="premium-size-selector">
          <label>Size:</label>
          <select
            value={selectedSize || ""}
            onChange={(e) => onSizeChange(cartItemKey, e.target.value)}
          >
            <option value="">Select size</option>
            {item.availableSizes?.map((size) => (
              <option
                key={size}
                value={size}
                disabled={item.availableQuantities[size] <= 0}
              >
                {size} {item.availableQuantities[size] <= 0 ? '(Out of stock)' : ''}
              </option>
            ))}
          </select>
        </div>
        
        <div className="premium-price-section">
          <div className="premium-price-display">

            <span className="premium-selling-price">
              ₹{itemPrice}
                {item.originalPrice && (
              <span className="premium-original-price ms-2 ">
                ₹{item.originalPrice}
              </span>
            )}
            {item.originalPrice && (
              <span className="premium-discount-badge ms-2">
                ({Math.round((1 - itemPrice/item.originalPrice) * 100)}% OFF)
              </span>
            )}
            </span>
          </div>
          
          <div className="premium-total-price">
            Total: ₹{(item.quantity * itemPrice).toFixed(2)}
          </div>
          
          {savings > 0 && (
            <div className="premium-savings">
              You save ₹{savings.toFixed(2)}
            </div>
          )}
        </div>
        
        <div className="premium-quantity-controls">
          <button
            className="premium-quantity-btn"
            onClick={() => onQuantityChange(cartItemKey, item.quantity - 1)}
          >
            −
          </button>
          <span className="premium-quantity-value">{item.quantity}</span>
          <button
            className="premium-quantity-btn"
            onClick={() => onQuantityChange(cartItemKey, item.quantity + 1)}
            disabled={
              selectedSize &&
              item.availableQuantities[selectedSize] <= item.quantity
            }
          >
            +
          </button>
        </div>
        
        <div className="premium-item-actions">
          <button
            className="premium-remove-btn"
            onClick={() => onRemove(cartItemKey)}
          >
            <i className="fa fa-trash"></i>
            Remove
          </button>
          <button
            className="premium-wishlist-btn"
            onClick={() => onMoveToWishlist(item)}
          >
            <i className="fa fa-heart"></i>
            Move to Wishlist
          </button>
        </div>
      </div>
    </div>
  );
};

export const MobileCartItem = ({ 
  item, 
  cartItemKey,
  onQuantityChange, 
  onRemove, 
  onMoveToWishlist, 
  onProductClick,
  onSizeChange,
  selectedSize 
}) => {
  const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
    ? item.variantPrices[selectedSize] 
    : item.sellingPrice;
    
  const savings = item.originalPrice ? (item.originalPrice - itemPrice) * item.quantity : 0;

  return (
    <div className="premium-mobile-cart-item">
      <div className="premium-mobile-image" onClick={() => onProductClick(item)}>
        <img
          src={
            item.productImage
              ? `https://api.dremerz.net/uploads/${item.productImage}`
              : "default-image.jpg"
          }
          loading="lazy"
          alt={item.productName || "Product"}
        />
        {/* {item.brandName && <div className="premium-mobile-badge">{item.brandName}</div>} */}
      </div>
      
      <div className="premium-mobile-details">
        <h4 onClick={() => onProductClick(item)}>{item.productName}</h4>
        
        {/* Size Selector for Mobile */}
        <div className="premium-mobile-size">
          <label>Size:</label>
          <select
            value={selectedSize || ""}
            onChange={(e) => onSizeChange(cartItemKey, e.target.value)}
          >
            <option value="">Select size</option>
            {item.availableSizes?.map((size) => (
              <option
                key={size}
                value={size}
                disabled={item.availableQuantities && item.availableQuantities[size] <= 0}
              >
                {size} {item.availableQuantities && item.availableQuantities[size] <= 0 ? '(Out of stock)' : ''}
              </option>
            ))}
          </select>
        </div>
        
        <div className="premium-mobile-price">
          <div className="premium-mobile-price-display">
            {item.originalPrice && (
              <span className="premium-mobile-original">₹{item.originalPrice}</span>
            )}
            <span className="premium-mobile-selling">₹{itemPrice}</span>
            {item.originalPrice && (
              <span className="premium-mobile-discount">
                ({Math.round((1 - itemPrice/item.originalPrice) * 100)}% OFF)
              </span>
            )}
          </div>
          
          <div className="premium-mobile-total">
            Total: ₹{(item.quantity * itemPrice).toFixed(2)}
          </div>
        </div>
        
        {savings > 0 && (
          <div className="premium-mobile-savings">
            You save ₹{savings.toFixed(2)}
          </div>
        )}
        
        <div className="premium-mobile-controls">
          <div className="premium-mobile-quantity me-2">
            <button
              className="premium-mobile-qty-btn"
              onClick={() => onQuantityChange(cartItemKey, item.quantity - 1)}
            >
              −
            </button>
            <span className="premium-mobile-qty-value">{item.quantity}</span>
            <button
              className="premium-mobile-qty-btn"
              onClick={() => onQuantityChange(cartItemKey, item.quantity + 1)}
              disabled={
                selectedSize &&
                item.availableQuantities &&
                item.availableQuantities[selectedSize] <= item.quantity
              }
            >
              +
            </button>
          </div>
          
          <div className="premium-mobile-actions">
            <button
              className="premium-mobile-remove"
              onClick={() => onRemove(cartItemKey)}
            >
              <i className="fa fa-trash"></i>
            </button>
            <button
              className="premium-mobile-wishlist"
              onClick={() => onMoveToWishlist(item)}
            >
              <i className="fa fa-heart"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

import React, { useState } from "react";
import axios from "axios";
import { showMyAlert } from "../../utils/alertService";
import { Link } from "react-router-dom";

const API_BASE_URL = "https://api.dremerz.net/api";

export const CheckoutSection = ({ 
  cartItems, 
  productSizes, 
  deliveryCharge, 
  onProceedToPay,
  address,
  setAddress,
  landmark,
  setLandmark,
  mobile2,
  setMobile2,
  pincode,
  setPincode,
  userData,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);


  const calculateSubtotal = () => {
    return cartItems.reduce((total, item) => {
      const selectedSize = productSizes[item.cartItemKey];
      const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
        ? item.variantPrices[selectedSize] 
        : item.sellingPrice;
      return total + (item.quantity * itemPrice);
    }, 0);
  };
  
  const calculateTotalSavings = () => {
    return cartItems.reduce((savings, item) => {
      if (!item.originalPrice) return savings;
      
      const selectedSize = productSizes[item.cartItemKey];
      const itemPrice = selectedSize && item.variantPrices?.[selectedSize] 
        ? item.variantPrices[selectedSize] 
        : item.sellingPrice;
        
      return savings + ((item.originalPrice - itemPrice) * item.quantity);
    }, 0);
  };

  const subtotal = calculateSubtotal();
  const totalSavings = calculateTotalSavings();
  const totalPayable = subtotal + deliveryCharge;

  const isFormValid = () => {
    const allSizesSelected = cartItems.every((item) => productSizes[item.cartItemKey]);
    return (
      address !== "" &&
      landmark !== "" &&
      pincode !== "" &&
      mobile2 !== "" &&
      deliveryCharge > 0 &&
      allSizesSelected
    );
  };

  // Save updated address to API + session
  const handleSaveAddress = async () => {
    setLoading(true);
    try {
      const updatedUser = {
        fullAddress: address,
        landmark: landmark,
        pincode: pincode,
        mobile: mobile2
      };

      await axios.put(`${API_BASE_URL}/Kalanjiyam_Users_Registration/${userData.id}`, updatedUser);

      // update sessionStorage
      const user = JSON.parse(sessionStorage.getItem("user"));
      sessionStorage.setItem("user", JSON.stringify({...user, ...updatedUser}));

      setIsEditing(false);
    } catch (error) {
      console.error("Error updating address:", error);
      showMyAlert({
        type: "danger",
        title: "Error",
        message: "Failed to update address. Please try again.",
        duration: 2500,   
      })
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="premium-checkout-section">
      <div className="premium-checkout-card">
        <h3>Order Summary</h3>
        
        <div className="premium-order-details">
          <div className="premium-order-row">
            <span>Subtotal ({cartItems.reduce((acc, item) => acc + item.quantity, 0)} items)</span>
            <span>₹{subtotal.toFixed(2)}</span>
          </div>
          
          {totalSavings > 0 && (
            <div className="premium-order-row premium-savings-row">
              <span>Your Savings</span>
              <span className="premium-savings-amount">-₹{totalSavings.toFixed(2)}</span>
            </div>
          )}
          
          <div className="premium-order-row">
            <span>Delivery Charge</span>
            <span>₹{deliveryCharge}</span>
          </div>
          
          <div className="premium-order-divider"></div>
          
          <div className="premium-order-total">
            <span>Total Payable</span>
            <span>₹{totalPayable.toFixed(2)}</span>
          </div>
        </div>

        {/* Address Card */}
        <div className="premium-address-section">
            <div className="d-flex justify-content-between align-items-center">
          <h4 className="m-0">Delivery Address</h4>
                    {
                        !isEditing && (
                        <button className="btn btn-sm premium-edit-address-btn" onClick={() => setIsEditing(true)}>
                            Edit
                        </button>
                        )
                    }
            </div>

          {!isEditing ? (
            <div className="address-card">
              <p className="m-0">{address}</p>
              <p className="m-0">{landmark}</p>
              <p className="m-0">Pincode: {pincode}</p>
              <p className="m-0">Mobile: {mobile2}</p>
            </div>
          ) : (
            <div className="edit-address-form">
              <div className="premium-form-group">
                <label>Full Address *</label>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                  placeholder="Enter your complete address"
                />
              </div>

              <div className="premium-form-row">
                <div className="premium-form-group">
                  <label>Landmark *</label>
                  <input
                    type="text"
                    value={landmark}
                    onChange={(e) => setLandmark(e.target.value)}
                    required
                    placeholder="Nearby landmark"
                  />
                </div>
                <div className="premium-form-group">
                  <label>Mobile Number *</label>
                  <input
                    type="text"
                    value={mobile2}
                    onChange={(e) => setMobile2(e.target.value)}
                    required
                    placeholder="Your mobile number"
                  />
                </div>
              </div>

              <div className="premium-form-group">
                <label>Pincode *</label>
                <input
                  type="number"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value.slice(0, 6))}
                  required
                  placeholder="6-digit pincode"
                />
              </div>

              <button
                className="btn premium-edit-address-btn"
                onClick={handleSaveAddress}
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Address"}
              </button>
            </div>
          )}
        </div>
        
        <button
          className={`premium-pay-btn ${isFormValid() ? '' : 'premium-pay-btn-disabled'}`}
          onClick={onProceedToPay}
          disabled={!isFormValid()}
        >
          Proceed to Pay ₹{totalPayable.toFixed(2)}
        </button>

        <div style={{ marginTop: "10px", marginBottom:0, textAlign: "left", fontSize: "12px", color: "#666", fontStyle: "italic" }}>
            <p className="premium-terms">
                By proceeding, you agree to our <Link to="/Terms/Conditions">Terms & Conditions</Link> and <Link to="/Privacy/Policy">Privacy Policy</Link> and No refund, for cancellation contact <b>support@kalanjiyam.in</b>.
            </p>
        </div>
      </div>
    </div>
  );
};
